import { backendApi } from "../dynamicBAseQuery";

export const jobManageEventsApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        eventsTableDatas: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `events`,
                body: { ...args }
            })
        }),

        getEventDropDown: builder.query({
            query: () => ({
                method: "GET",
                url: `eventDropDown`
            })
        }),

        updateJobManageEvents: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `update`,
                body: { ...args }
            })
        }),
        makeReferralCommission: builder.mutation({
            query: (args) => ({
                method: 'POST',
                url: 'makeReferralCommission',
                body: { ...args }
            })
        }),

        makeContractReferralCommission: builder.mutation({
            query: (args) => ({
                method: 'POST',
                url: 'makeContractReferralCommission',
                body: { ...args }
            })
        }),
        
        makeCommissionManagement: builder.mutation({
            query: (args) => ({
                method: 'POST',
                url: 'makeCommissionManagement',
                body: { ...args }
            })
        }),
    })
})

export const {
    useEventsTableDatasMutation,
    useGetEventDropDownQuery,
    useUpdateJobManageEventsMutation,
    useMakeReferralCommissionMutation,
    useMakeContractReferralCommissionMutation,
    useMakeCommissionManagementMutation,
} = jobManageEventsApi